export const PHONE_NUMBER_PATTERN = "(###) ###-####";
export const DOB_PATTERN = "##/##/####";
export const SSN_PATTERN = "###-##-####";
export const TIN_PATTERN = "##-#######";
